// Generated country facts snapshot for Mundely.
// Currency: Unicode CLDR supplemental currencyData, active tender on 2026-10-08.
// Plug types: benjiao/world-plugs (IEC-derived dataset), snapshot 2026-10-08.
// Driving side: WorldStandards left/right-driving country table, updated 2026-01-23.
export const COUNTRY_FACTS_DATASET_META = {
  version: "2026-10-08",
  verifiedAt: "2026-10-08",
  sources: {
    currencies: "https://raw.githubusercontent.com/unicode-org/cldr/main/common/supplemental/supplementalData.xml",
    plugTypes: "https://raw.githubusercontent.com/benjiao/world-plugs/master/world-plugs.csv",
    drivingSide: "https://www.worldstandards.eu/cars/list-of-left-driving-countries/"
  }
} as const;
export const COUNTRY_FACTS_DATASET_VERSION = COUNTRY_FACTS_DATASET_META.version;
export type CountryDrivingSide = "left" | "right";
export interface MundelyCountryFact { currencies: string[]; plugTypes: string[]; drivingSide: CountryDrivingSide; }
export const MUNDELY_COUNTRY_FACTS: Record<string, MundelyCountryFact> = {
  "AC": { currencies: ["SHP"], plugTypes: [], drivingSide: "right" },
  "AD": { currencies: ["EUR"], plugTypes: ["C","F"], drivingSide: "right" },
  "AE": { currencies: ["AED"], plugTypes: ["C","D","G"], drivingSide: "right" },
  "AF": { currencies: ["AFN"], plugTypes: ["C","F"], drivingSide: "right" },
  "AG": { currencies: ["XCD"], plugTypes: ["A","B"], drivingSide: "left" },
  "AI": { currencies: ["XCD"], plugTypes: ["A"], drivingSide: "left" },
  "AL": { currencies: ["ALL"], plugTypes: ["C","F"], drivingSide: "right" },
  "AM": { currencies: ["AMD"], plugTypes: ["C","F"], drivingSide: "right" },
  "AO": { currencies: ["AOA"], plugTypes: ["C"], drivingSide: "right" },
  "AR": { currencies: ["ARS"], plugTypes: ["C","I"], drivingSide: "right" },
  "AS": { currencies: ["USD"], plugTypes: ["A","B","F","I"], drivingSide: "right" },
  "AT": { currencies: ["EUR"], plugTypes: ["C","F"], drivingSide: "right" },
  "AU": { currencies: ["AUD"], plugTypes: ["I"], drivingSide: "left" },
  "AW": { currencies: ["AWG"], plugTypes: ["A","B","F"], drivingSide: "right" },
  "AX": { currencies: ["EUR"], plugTypes: [], drivingSide: "right" },
  "AZ": { currencies: ["AZN"], plugTypes: ["C","F"], drivingSide: "right" },
  "BA": { currencies: ["BAM"], plugTypes: ["C","F"], drivingSide: "right" },
  "BB": { currencies: ["BBD"], plugTypes: ["A","B"], drivingSide: "left" },
  "BD": { currencies: ["BDT"], plugTypes: ["C","D","G","K"], drivingSide: "left" },
  "BE": { currencies: ["EUR"], plugTypes: ["C","E"], drivingSide: "right" },
  "BF": { currencies: ["XOF"], plugTypes: ["C","E"], drivingSide: "right" },
  "BG": { currencies: ["EUR"], plugTypes: ["C","F"], drivingSide: "right" },
  "BH": { currencies: ["BHD"], plugTypes: ["G"], drivingSide: "right" },
  "BI": { currencies: ["BIF"], plugTypes: ["C","E"], drivingSide: "right" },
  "BJ": { currencies: ["XOF"], plugTypes: ["C","E"], drivingSide: "right" },
  "BL": { currencies: ["EUR"], plugTypes: [], drivingSide: "right" },
  "BM": { currencies: ["BMD"], plugTypes: ["A","B"], drivingSide: "left" },
  "BN": { currencies: ["BND"], plugTypes: ["G"], drivingSide: "left" },
  "BO": { currencies: ["BOB"], plugTypes: ["A","C"], drivingSide: "right" },
  "BQ": { currencies: ["USD"], plugTypes: [], drivingSide: "right" },
  "BR": { currencies: ["BRL"], plugTypes: ["C","N"], drivingSide: "right" },
  "BS": { currencies: ["BSD"], plugTypes: ["A","B"], drivingSide: "left" },
  "BT": { currencies: ["BTN","INR"], plugTypes: ["C","D","F","G","M"], drivingSide: "left" },
  "BV": { currencies: ["NOK"], plugTypes: [], drivingSide: "right" },
  "BW": { currencies: ["BWP"], plugTypes: ["D","G","M"], drivingSide: "left" },
  "BY": { currencies: ["BYN"], plugTypes: ["C","F"], drivingSide: "right" },
  "BZ": { currencies: ["BZD"], plugTypes: ["A","B","G"], drivingSide: "right" },
  "CA": { currencies: ["CAD"], plugTypes: ["A","B"], drivingSide: "right" },
  "CC": { currencies: ["AUD"], plugTypes: [], drivingSide: "left" },
  "CD": { currencies: ["CDF"], plugTypes: ["C","D","E"], drivingSide: "right" },
  "CF": { currencies: ["XAF"], plugTypes: ["C","E"], drivingSide: "right" },
  "CG": { currencies: ["XAF"], plugTypes: ["C","E"], drivingSide: "right" },
  "CH": { currencies: ["CHF"], plugTypes: ["C","J"], drivingSide: "right" },
  "CI": { currencies: ["XOF"], plugTypes: ["C","E"], drivingSide: "right" },
  "CK": { currencies: ["NZD"], plugTypes: ["I"], drivingSide: "left" },
  "CL": { currencies: ["CLP"], plugTypes: ["C","L"], drivingSide: "right" },
  "CM": { currencies: ["XAF"], plugTypes: ["C","E"], drivingSide: "right" },
  "CN": { currencies: ["CNY"], plugTypes: ["A","C","I"], drivingSide: "right" },
  "CO": { currencies: ["COP"], plugTypes: ["A","B"], drivingSide: "right" },
  "CR": { currencies: ["CRC"], plugTypes: ["A","B"], drivingSide: "right" },
  "CU": { currencies: ["CUP"], plugTypes: ["A","B"], drivingSide: "right" },
  "CV": { currencies: ["CVE"], plugTypes: ["C","F"], drivingSide: "right" },
  "CW": { currencies: ["XCG"], plugTypes: ["A","B","C","F"], drivingSide: "right" },
  "CX": { currencies: ["AUD"], plugTypes: [], drivingSide: "left" },
  "CY": { currencies: ["EUR"], plugTypes: ["G"], drivingSide: "left" },
  "CZ": { currencies: ["CZK"], plugTypes: ["C","E"], drivingSide: "right" },
  "DE": { currencies: ["EUR"], plugTypes: ["C","F"], drivingSide: "right" },
  "DG": { currencies: ["USD"], plugTypes: [], drivingSide: "right" },
  "DJ": { currencies: ["DJF"], plugTypes: ["C","E"], drivingSide: "right" },
  "DK": { currencies: ["DKK"], plugTypes: ["C","F","E","K"], drivingSide: "right" },
  "DM": { currencies: ["XCD"], plugTypes: ["D","G"], drivingSide: "left" },
  "DO": { currencies: ["DOP"], plugTypes: ["A","B"], drivingSide: "right" },
  "DZ": { currencies: ["DZD"], plugTypes: ["C","F"], drivingSide: "right" },
  "EA": { currencies: ["EUR"], plugTypes: [], drivingSide: "right" },
  "EC": { currencies: ["USD"], plugTypes: ["A","B"], drivingSide: "right" },
  "EE": { currencies: ["EUR"], plugTypes: ["C","F"], drivingSide: "right" },
  "EG": { currencies: ["EGP"], plugTypes: ["C","F"], drivingSide: "right" },
  "EH": { currencies: ["MAD"], plugTypes: [], drivingSide: "right" },
  "ER": { currencies: ["ERN"], plugTypes: ["C","L"], drivingSide: "right" },
  "ES": { currencies: ["EUR"], plugTypes: ["C","F"], drivingSide: "right" },
  "ET": { currencies: ["ETB"], plugTypes: ["C","E","F","L"], drivingSide: "right" },
  "EU": { currencies: ["EUR"], plugTypes: [], drivingSide: "right" },
  "FI": { currencies: ["EUR"], plugTypes: ["C","F"], drivingSide: "right" },
  "FJ": { currencies: ["FJD"], plugTypes: ["I"], drivingSide: "left" },
  "FK": { currencies: ["FKP"], plugTypes: ["G"], drivingSide: "left" },
  "FM": { currencies: ["USD"], plugTypes: ["A","B"], drivingSide: "right" },
  "FO": { currencies: ["DKK"], plugTypes: ["C","F","E","K"], drivingSide: "right" },
  "FR": { currencies: ["EUR"], plugTypes: ["C","E"], drivingSide: "right" },
  "GA": { currencies: ["XAF"], plugTypes: ["C"], drivingSide: "right" },
  "GB": { currencies: ["GBP"], plugTypes: ["G"], drivingSide: "left" },
  "GD": { currencies: ["XCD"], plugTypes: ["G"], drivingSide: "left" },
  "GE": { currencies: ["GEL"], plugTypes: ["C","F"], drivingSide: "right" },
  "GF": { currencies: ["EUR"], plugTypes: ["C","D","E"], drivingSide: "right" },
  "GG": { currencies: ["GBP"], plugTypes: [], drivingSide: "left" },
  "GH": { currencies: ["GHS"], plugTypes: ["D","G"], drivingSide: "right" },
  "GI": { currencies: ["GIP"], plugTypes: ["C","G"], drivingSide: "right" },
  "GL": { currencies: ["DKK"], plugTypes: ["C","F","E","K"], drivingSide: "right" },
  "GM": { currencies: ["GMD"], plugTypes: ["G"], drivingSide: "right" },
  "GN": { currencies: ["GNF"], plugTypes: ["C","F","K"], drivingSide: "right" },
  "GP": { currencies: ["EUR"], plugTypes: ["C","D","E"], drivingSide: "right" },
  "GQ": { currencies: ["XAF"], plugTypes: ["C","E"], drivingSide: "right" },
  "GR": { currencies: ["EUR"], plugTypes: ["C","F"], drivingSide: "right" },
  "GS": { currencies: ["GBP"], plugTypes: [], drivingSide: "right" },
  "GT": { currencies: ["GTQ"], plugTypes: ["A","B"], drivingSide: "right" },
  "GU": { currencies: ["USD"], plugTypes: ["A","B"], drivingSide: "right" },
  "GW": { currencies: ["XOF"], plugTypes: ["C"], drivingSide: "right" },
  "GY": { currencies: ["GYD"], plugTypes: ["A","B","D","G"], drivingSide: "left" },
  "HK": { currencies: ["HKD"], plugTypes: ["G","D"], drivingSide: "left" },
  "HM": { currencies: ["AUD"], plugTypes: [], drivingSide: "right" },
  "HN": { currencies: ["HNL"], plugTypes: ["A","B"], drivingSide: "right" },
  "HR": { currencies: ["EUR"], plugTypes: ["C","F"], drivingSide: "right" },
  "HT": { currencies: ["HTG","USD"], plugTypes: ["A","B"], drivingSide: "right" },
  "HU": { currencies: ["HUF"], plugTypes: ["C","F"], drivingSide: "right" },
  "IC": { currencies: ["EUR"], plugTypes: [], drivingSide: "right" },
  "ID": { currencies: ["IDR"], plugTypes: ["C","F"], drivingSide: "left" },
  "IE": { currencies: ["EUR"], plugTypes: ["G"], drivingSide: "left" },
  "IL": { currencies: ["ILS"], plugTypes: ["C","H","M"], drivingSide: "right" },
  "IM": { currencies: ["GBP"], plugTypes: ["C","G"], drivingSide: "left" },
  "IN": { currencies: ["INR"], plugTypes: ["C","D","M"], drivingSide: "left" },
  "IO": { currencies: ["USD"], plugTypes: [], drivingSide: "right" },
  "IQ": { currencies: ["IQD"], plugTypes: ["C","D","G"], drivingSide: "right" },
  "IR": { currencies: ["IRR"], plugTypes: ["C","F"], drivingSide: "right" },
  "IS": { currencies: ["ISK"], plugTypes: ["C","F"], drivingSide: "right" },
  "IT": { currencies: ["EUR"], plugTypes: ["C","F","L"], drivingSide: "right" },
  "JE": { currencies: ["GBP"], plugTypes: [], drivingSide: "left" },
  "JM": { currencies: ["JMD"], plugTypes: ["A","B"], drivingSide: "left" },
  "JO": { currencies: ["JOD"], plugTypes: ["B","C","D","F","G","J"], drivingSide: "right" },
  "JP": { currencies: ["JPY"], plugTypes: ["A","B"], drivingSide: "left" },
  "KE": { currencies: ["KES"], plugTypes: ["G"], drivingSide: "left" },
  "KG": { currencies: ["KGS"], plugTypes: ["C","F"], drivingSide: "right" },
  "KH": { currencies: ["KHR"], plugTypes: ["A","C","G"], drivingSide: "right" },
  "KI": { currencies: ["AUD"], plugTypes: ["I"], drivingSide: "left" },
  "KM": { currencies: ["KMF"], plugTypes: ["C","E"], drivingSide: "right" },
  "KN": { currencies: ["XCD"], plugTypes: ["A","B","D","G"], drivingSide: "left" },
  "KP": { currencies: ["KPW"], plugTypes: ["A","C","F"], drivingSide: "right" },
  "KR": { currencies: ["KRW"], plugTypes: ["C","F"], drivingSide: "right" },
  "KW": { currencies: ["KWD"], plugTypes: ["C","G"], drivingSide: "right" },
  "KY": { currencies: ["KYD"], plugTypes: ["A","B"], drivingSide: "left" },
  "KZ": { currencies: ["KZT"], plugTypes: ["C","F"], drivingSide: "right" },
  "LA": { currencies: ["LAK"], plugTypes: ["A","B","C","E","F"], drivingSide: "right" },
  "LB": { currencies: ["LBP"], plugTypes: ["A","B","C","D","G"], drivingSide: "right" },
  "LC": { currencies: ["XCD"], plugTypes: ["G"], drivingSide: "left" },
  "LI": { currencies: ["CHF"], plugTypes: ["C","J"], drivingSide: "right" },
  "LK": { currencies: ["LKR"], plugTypes: ["D","M","G"], drivingSide: "left" },
  "LR": { currencies: ["LRD"], plugTypes: ["A","B","C","E","F"], drivingSide: "right" },
  "LS": { currencies: ["ZAR","LSL"], plugTypes: ["M"], drivingSide: "left" },
  "LT": { currencies: ["EUR"], plugTypes: ["C","F"], drivingSide: "right" },
  "LU": { currencies: ["EUR"], plugTypes: ["C","F"], drivingSide: "right" },
  "LV": { currencies: ["EUR"], plugTypes: ["C","F"], drivingSide: "right" },
  "LY": { currencies: ["LYD"], plugTypes: ["C","D","F","L"], drivingSide: "right" },
  "MA": { currencies: ["MAD"], plugTypes: ["C","E"], drivingSide: "right" },
  "MC": { currencies: ["EUR"], plugTypes: ["C","D","E","F"], drivingSide: "right" },
  "MD": { currencies: ["MDL"], plugTypes: ["C","F"], drivingSide: "right" },
  "ME": { currencies: ["EUR"], plugTypes: ["C","F"], drivingSide: "right" },
  "MF": { currencies: ["EUR"], plugTypes: ["C","F"], drivingSide: "right" },
  "MG": { currencies: ["MGA"], plugTypes: ["C","D","E","J","K"], drivingSide: "right" },
  "MH": { currencies: ["USD"], plugTypes: [], drivingSide: "right" },
  "MK": { currencies: ["MKD"], plugTypes: ["C","F"], drivingSide: "right" },
  "ML": { currencies: ["XOF"], plugTypes: ["C","E"], drivingSide: "right" },
  "MM": { currencies: ["MMK"], plugTypes: ["C","D","F","G"], drivingSide: "right" },
  "MN": { currencies: ["MNT"], plugTypes: ["C","E"], drivingSide: "right" },
  "MO": { currencies: ["MOP"], plugTypes: ["D","M","G","F"], drivingSide: "left" },
  "MP": { currencies: ["USD"], plugTypes: [], drivingSide: "right" },
  "MQ": { currencies: ["EUR"], plugTypes: ["C","D","E"], drivingSide: "right" },
  "MR": { currencies: ["MRU"], plugTypes: ["C"], drivingSide: "right" },
  "MS": { currencies: ["XCD"], plugTypes: ["A","B"], drivingSide: "left" },
  "MT": { currencies: ["EUR"], plugTypes: ["G"], drivingSide: "left" },
  "MU": { currencies: ["MUR"], plugTypes: ["C","G"], drivingSide: "left" },
  "MV": { currencies: ["MVR"], plugTypes: ["A","C","D","G","J","K","L"], drivingSide: "left" },
  "MW": { currencies: ["MWK"], plugTypes: ["G"], drivingSide: "left" },
  "MX": { currencies: ["MXN"], plugTypes: ["A","B"], drivingSide: "right" },
  "MY": { currencies: ["MYR"], plugTypes: ["A","C","G","M"], drivingSide: "left" },
  "MZ": { currencies: ["MZN"], plugTypes: ["C","F","M"], drivingSide: "left" },
  "NA": { currencies: ["NAD","ZAR"], plugTypes: ["D","M"], drivingSide: "left" },
  "NC": { currencies: ["XPF"], plugTypes: ["C","F"], drivingSide: "right" },
  "NE": { currencies: ["XOF"], plugTypes: ["A","B","C","D","E","F"], drivingSide: "right" },
  "NF": { currencies: ["AUD"], plugTypes: [], drivingSide: "left" },
  "NG": { currencies: ["NGN"], plugTypes: ["D","G"], drivingSide: "right" },
  "NI": { currencies: ["NIO"], plugTypes: ["A","B"], drivingSide: "right" },
  "NL": { currencies: ["EUR"], plugTypes: ["C","F"], drivingSide: "right" },
  "NO": { currencies: ["NOK"], plugTypes: ["C","F"], drivingSide: "right" },
  "NP": { currencies: ["NPR"], plugTypes: ["C","D","M"], drivingSide: "left" },
  "NR": { currencies: ["AUD"], plugTypes: ["I"], drivingSide: "left" },
  "NU": { currencies: ["NZD"], plugTypes: [], drivingSide: "left" },
  "NZ": { currencies: ["NZD"], plugTypes: ["I"], drivingSide: "left" },
  "OM": { currencies: ["OMR"], plugTypes: ["C","G"], drivingSide: "right" },
  "PA": { currencies: ["PAB","USD"], plugTypes: ["A","B"], drivingSide: "right" },
  "PE": { currencies: ["PEN"], plugTypes: ["A","B","C"], drivingSide: "right" },
  "PF": { currencies: ["XPF"], plugTypes: [], drivingSide: "right" },
  "PG": { currencies: ["PGK"], plugTypes: ["I"], drivingSide: "left" },
  "PH": { currencies: ["PHP"], plugTypes: ["A","B","C"], drivingSide: "right" },
  "PK": { currencies: ["PKR"], plugTypes: ["C","D","G","M"], drivingSide: "left" },
  "PL": { currencies: ["PLN"], plugTypes: ["C","E"], drivingSide: "right" },
  "PM": { currencies: ["EUR"], plugTypes: [], drivingSide: "right" },
  "PN": { currencies: ["NZD"], plugTypes: [], drivingSide: "left" },
  "PR": { currencies: ["USD"], plugTypes: ["A","B"], drivingSide: "right" },
  "PS": { currencies: ["ILS","JOD"], plugTypes: [], drivingSide: "right" },
  "PT": { currencies: ["EUR"], plugTypes: ["C","F"], drivingSide: "right" },
  "PW": { currencies: ["USD"], plugTypes: ["A","B"], drivingSide: "right" },
  "PY": { currencies: ["PYG"], plugTypes: ["C"], drivingSide: "right" },
  "QA": { currencies: ["QAR"], plugTypes: ["D","G"], drivingSide: "right" },
  "RE": { currencies: ["EUR"], plugTypes: ["E"], drivingSide: "right" },
  "RO": { currencies: ["RON"], plugTypes: ["C","F"], drivingSide: "right" },
  "RS": { currencies: ["RSD"], plugTypes: ["C","F"], drivingSide: "right" },
  "RU": { currencies: ["RUB"], plugTypes: ["C","F"], drivingSide: "right" },
  "RW": { currencies: ["RWF"], plugTypes: ["C","J"], drivingSide: "right" },
  "SA": { currencies: ["SAR"], plugTypes: ["G"], drivingSide: "right" },
  "SB": { currencies: ["SBD"], plugTypes: ["I","G"], drivingSide: "left" },
  "SC": { currencies: ["SCR"], plugTypes: ["G"], drivingSide: "left" },
  "SD": { currencies: ["SDG"], plugTypes: ["C","D"], drivingSide: "right" },
  "SE": { currencies: ["SEK"], plugTypes: ["C","F"], drivingSide: "right" },
  "SG": { currencies: ["SGD"], plugTypes: ["C","G","M"], drivingSide: "left" },
  "SH": { currencies: ["SHP"], plugTypes: [], drivingSide: "left" },
  "SI": { currencies: ["EUR"], plugTypes: ["C","F"], drivingSide: "right" },
  "SJ": { currencies: ["NOK"], plugTypes: [], drivingSide: "right" },
  "SK": { currencies: ["EUR"], plugTypes: ["C","E"], drivingSide: "right" },
  "SL": { currencies: ["SLE"], plugTypes: ["D","G"], drivingSide: "right" },
  "SM": { currencies: ["EUR"], plugTypes: ["C","F","L"], drivingSide: "right" },
  "SN": { currencies: ["XOF"], plugTypes: ["C","D","E","K"], drivingSide: "right" },
  "SO": { currencies: ["SOS"], plugTypes: ["C"], drivingSide: "right" },
  "SR": { currencies: ["SRD"], plugTypes: ["C","F"], drivingSide: "left" },
  "SS": { currencies: ["SSP"], plugTypes: [], drivingSide: "right" },
  "ST": { currencies: ["STN"], plugTypes: ["C","F"], drivingSide: "right" },
  "SV": { currencies: ["USD"], plugTypes: ["A","B"], drivingSide: "right" },
  "SX": { currencies: ["XCG"], plugTypes: [], drivingSide: "right" },
  "SY": { currencies: ["SYP"], plugTypes: ["C","E","L"], drivingSide: "right" },
  "SZ": { currencies: ["SZL"], plugTypes: ["M"], drivingSide: "left" },
  "TA": { currencies: ["GBP"], plugTypes: [], drivingSide: "right" },
  "TC": { currencies: ["USD"], plugTypes: ["A","B"], drivingSide: "left" },
  "TD": { currencies: ["XAF"], plugTypes: ["C","D","E","F"], drivingSide: "right" },
  "TF": { currencies: ["EUR"], plugTypes: [], drivingSide: "right" },
  "TG": { currencies: ["XOF"], plugTypes: ["C"], drivingSide: "right" },
  "TH": { currencies: ["THB"], plugTypes: ["A","B","C","F"], drivingSide: "left" },
  "TJ": { currencies: ["TJS"], plugTypes: ["C","F","I"], drivingSide: "right" },
  "TK": { currencies: ["NZD"], plugTypes: [], drivingSide: "left" },
  "TL": { currencies: ["USD"], plugTypes: ["C","E","F","I"], drivingSide: "left" },
  "TM": { currencies: ["TMT"], plugTypes: ["B","C","F"], drivingSide: "right" },
  "TN": { currencies: ["TND"], plugTypes: ["C","E"], drivingSide: "right" },
  "TO": { currencies: ["TOP"], plugTypes: ["I"], drivingSide: "left" },
  "TR": { currencies: ["TRY"], plugTypes: ["C","F"], drivingSide: "right" },
  "TT": { currencies: ["TTD"], plugTypes: ["A","B"], drivingSide: "left" },
  "TV": { currencies: ["AUD"], plugTypes: ["I"], drivingSide: "left" },
  "TW": { currencies: ["TWD"], plugTypes: ["A","B"], drivingSide: "right" },
  "TZ": { currencies: ["TZS"], plugTypes: ["D","G"], drivingSide: "left" },
  "UA": { currencies: ["UAH"], plugTypes: ["C","F"], drivingSide: "right" },
  "UG": { currencies: ["UGX"], plugTypes: ["G"], drivingSide: "left" },
  "UM": { currencies: ["USD"], plugTypes: [], drivingSide: "right" },
  "US": { currencies: ["USD"], plugTypes: ["A","B"], drivingSide: "right" },
  "UY": { currencies: ["UYU"], plugTypes: ["C","F","I","L"], drivingSide: "right" },
  "UZ": { currencies: ["UZS"], plugTypes: ["C","I"], drivingSide: "right" },
  "VA": { currencies: ["EUR"], plugTypes: [], drivingSide: "right" },
  "VC": { currencies: ["XCD"], plugTypes: ["A","C","E","G","I","K"], drivingSide: "left" },
  "VE": { currencies: ["VES"], plugTypes: ["A","B"], drivingSide: "right" },
  "VG": { currencies: ["USD"], plugTypes: ["A","B"], drivingSide: "left" },
  "VI": { currencies: ["USD"], plugTypes: ["A","B"], drivingSide: "left" },
  "VN": { currencies: ["VND"], plugTypes: ["A","C","F"], drivingSide: "right" },
  "VU": { currencies: ["VUV"], plugTypes: ["C","G","I"], drivingSide: "right" },
  "WF": { currencies: ["XPF"], plugTypes: [], drivingSide: "right" },
  "WS": { currencies: ["WST"], plugTypes: ["I"], drivingSide: "left" },
  "XK": { currencies: ["EUR"], plugTypes: [], drivingSide: "right" },
  "XS": { currencies: [], plugTypes: [], drivingSide: "right" },
  "XT": { currencies: [], plugTypes: [], drivingSide: "right" },
  "YE": { currencies: ["YER"], plugTypes: ["A","D","G"], drivingSide: "right" },
  "YT": { currencies: ["EUR"], plugTypes: [], drivingSide: "right" },
  "ZA": { currencies: ["ZAR"], plugTypes: ["C","D","M","N"], drivingSide: "left" },
  "ZM": { currencies: ["ZMW"], plugTypes: ["C","D","G"], drivingSide: "left" },
  "ZW": { currencies: ["ZWG","USD"], plugTypes: ["D","G"], drivingSide: "left" },
};
